import dice from "./dice.js";
import slice from "./slice.js";

export default function(parent, x0, y0, x1, y1) {
  (parent.depth & 1 ? slice : dice)(parent, x0, y0, x1, y1);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-hierarchy/src/treemap/sliceDice.js
// module id = 815
// module chunks = 0